// extracted by mini-css-extract-plugin
export default {"cls1":"VeloStepperStep-Step_cls1__lMEfO","cls2":"VeloStepperStep-Step_cls2__nILTJ VeloStepperStep-Step_cls1__lMEfO","last":"VeloStepperStep-Step_last__9-szq"};